/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { sendEvent } from "./interface";

export const trackDigSigValidationTriggered = count => {
  sendEvent("DigSig", "Validation", "triggered", {}, count);
};

export const trackDigSigValidationTimeTaken = time => {
  sendEvent("DigSig", "Validation", "Time Taken", {}, time);
};

export const trackDigSigCount = count => {
  sendEvent("DigSig", "Validation", "Signature Count", {}, count);
};

export const trackDigSigTypes = types => {
  sendEvent("DigSig", "Validation", "Signature Types", {}, types);
};

export const trackDigSigSubFilters = subFilters => {
  sendEvent("DigSig", "Validation", "SubFilters", {}, subFilters);
};

export const trackDigSigValidationStatus = ({ status, validationIdentifiers }) => {
  sendEvent("DigSig", "Validation", "Status", {}, { status, validationIdentifiers });
};

export const trackDigSigValidatedBy = validatedBy => {
  sendEvent("DigSig", "Validation", "Validated By", {}, validatedBy);
};

export const trackDigSigTrustSources = trustSources => {
  sendEvent("DigSig", "Validation", "Trust Sources", {}, trustSources);
};

export const trackDigSigLTV = () => {
  sendEvent("DigSig", "Validation", "LTV Signature");
};

export const trackDigSigUnsupportedSignatures = subFilters => {
  sendEvent("DigSig", "Validation", "Unsupported", {}, subFilters);
};

export const trackDigSigValidationAPIError = error => {
  sendEvent("DigSig", "Validation", "Adobe Sign API Error", {}, error);
};

export const trackDigSigPanelOpen = () => {
  sendEvent("DigSig", "RHP", "Open");
};

export const trackDigSigExpandSignatureDetails = () => {
  sendEvent("DigSig", "RHP", "Expand Signature Details");
};

export const trackDigSigShowValidateButton = () => {
  sendEvent("DigSig", "RHP", "Show Validate Button");
};

export const trackDigSigValidateButtonClick = () => {
  sendEvent("DigSig", "RHP", "Validate Button Click");
};

export const trackDigSigCertificateViewerOpen = () => {
  sendEvent("DigSig", "Certificate Viewer", "Open");
};

export const trackDigSigCertificateViewerClose = () => {
  sendEvent("DigSig", "Certificate Viewer", "Close");
};

export const trackDigSigCertificateViewerTabOpen = tabName => {
  sendEvent("DigSig", "Certificate Viewer", "Tab Open", {}, tabName);
};

export const trackDigSigCertificateListClick = () => {
  sendEvent("DigSig", "Certificate Viewer", "Certificate List Click");
};

export const trackDigSigPolicyStatementOpen = () => {
  sendEvent("DigSig", "Certificate Viewer", "Policy Statement Open");
};

export const trackDigSigBannerShow = () => {
  sendEvent("DigSig", "Banner", "Show");
};

export const trackDigSigBannerShowMoreCTAClick = () => {
  sendEvent("DigSig", "Banner", "Show More Button Click");
};

export const trackDigSigBannerClose = closedBy => {
  sendEvent("DigSig", "Banner", "Close", {}, closedBy);
};

export const trackDocumentPermissionShow = () => {
  sendEvent("DigSig", "Document Permission Toast", "Show");
};
